import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';
import CloseIcon from '@rsuite/icons/Close';
import { Icon } from '@rsuite/icons';
import ReactImageMagnify from 'react-image-magnify';
import { Magnifier, GlassMagnifier } from 'react-image-magnifiers';
import {
  Input,
  InputGroup,
  Table,
  Button,
  ButtonGroup,
  CheckPicker,
  InputPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Modal,
  Col,
  ButtonToolbar,
  FlexboxGrid,
  Dropdown,
  Tooltip,
  IconButton,
  Whisper,
  Drawer,
  Placeholder,
  Pagination
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';

interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string,
    ProductTypeCode: string,
    ProductCode: string,
    ProductId: string,
    ProductName: string,
    Description: string,
    SizeUnit: "Inch",
    Length: 0,
    Width: 0,
    Height: 0,
    FinishCode: null,
    ColorCode: null,
    NetWeight: 0,
    GrossWeight: 0,
    HSNCode: string,
    SellingPriceCurrency: string,
    SellingPriceUnit: string,
    SellingPrice: 0,
    ProductCost: 0,
    SearchKeyword: string,
    MOQ: string,
    ProductDesigner: null,
    MadeBy: null,
    CategoryName: string,
    ProductTypeName: null,
    cbm: null,
    FinishName: null,
    ColorName: null,
    BuyerName: null,
    BuyerSku: null,
    Total_CBM: null,
    Total_CFT: null,
    TwentyFT: null,
    FortyFT: null,
    FortyHQ: null,
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
   ProductionDetail: [
      {
          id: string,
          ProductCode: string,
          MaterialNm: string,
          MaterialFinishNm:string,
          MatNetWeight: 0,
          MaterialCode: string,
          MaterialFinishCode: string
      }
  ],
    // Add other attributes if needed
  };
}

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const sizeUnit = [
  'Inch',
  'CM'
  
].map(item => ({ label: item, value: item }));
const { Column, HeaderCell, Cell } = Table;

const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  return (
    <Cell {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <input
          className="rs-input"
          defaultValue={rowData[dataKey]}
          onChange={event => {
            onChange && onChange(rowData.id, dataKey, event.target.value);
          }}
        />
      ) : (
        <span className="table-content-edit-span">{rowData[dataKey]}</span>
      )}
    </Cell>
  );
};

const ActionCell = ({ rowData, dataKey, onClick, ...props }) => {
  return (
    <Cell {...props} style={{ padding: '6px' }}>
      <Button
        appearance="default"
        active
        onClick={() => {
          onClick(rowData.id);
        }}
      >
        {rowData.status === 'EDIT' ? <Icon as={CheckIcon} /> : <Icon as={EditIcon} />}
      </Button>
    </Cell>
  );
};

const DataTable = () => {
  const ipp = 'http://192.168.1.23:1337';
  // const [data, setData] = React.useState(defaultData);
  const [data123, setData123] = useState<RowData[]>([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [activePage, setActivePage] = React.useState(1);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  // const [editedData, setEditedData] = useState({ attributes: { ProductId: '' } });
  useEffect(() => {
    fetchData();
  }, [data123]);
  const fetchData = async () => {
    const response = await fetch(`${ipp}/api/products?populate=*&pagination[page]=${activePage}`);
    const json = await response.json();
    setData123(json.data);
    setMeta123(json.meta);
    setPagination(json.meta.pagination); 
  };

  // console.log(data123)

  // const handleEditState = id => {
  //   const nextData = Object.assign([], data);
  //   const activeItem = nextData.find(item => item.id === id);
  //   activeItem.status = activeItem.status ? null : 'EDIT';
  //   setData(nextData);
  // };
  
  const [checkedKeys, setCheckedKeys] = useState<number[]>([]);
  const [showtab, setShowtab] = useState(1);
  const [showDrawer, setShowDrawer] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState();
  const [modeldata, setmodeldata] = React.useState([])
  const [multipleImages, setMultipleImages] = useState([]);
  const handleOpen = (value, prdcd) => {
    setSize(value);
    setOpen(true);
    const newArray = [...data123];
    const filteredData = newArray.filter((item) => item.attributes.ProductId === prdcd);
    setmodeldata(filteredData);
    if (filteredData.length > 0) {
      const multipleImagesData = filteredData[0].attributes.MultipleImage?.data;
      setMultipleImages(multipleImagesData || []);
    }
  };
  const handleClose = () => setOpen(false);
  let checked = false;
  let indeterminate = false;
  if (checkedKeys.length === data123.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < data123.length) {
    indeterminate = true;
  }
  
  const data1 = ['Eugenia', 'Bryan', 'Linda', 'Nancy', 'Lloyd', 'Alice', 'Julia', 'Albert'].map(
    item => ({ label: item, value: item })
  );
  const handletab = (e) => {
    setShowtab(e);
    const x = document.getElementById('row')
    const y = document.getElementById('second')
    if (x?.click) {
      x.hidden = true
    }
    if (x?.click) {
      y.hidden = false
    }
  };
  const handletab2 = (e) => {
    setShowtab(e);
    const x = document.getElementById('row')
    const y = document.getElementById('second')
    if (y?.click) {
      y.hidden = true
    }
    if (y?.click) {
      x.hidden = false
    }
  };
  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(true);
  const handleClick1 = () => {
    handletab(2)
    setIsActive1(!isActive1);
    setIsActive2(false);
  }
  const handleClick2 = () => {
    handletab2(1)
    setIsActive1(isActive2);
    setIsActive2(true);

  };
  const tooltip = (
    <Tooltip>
      List View
    </Tooltip>
  );
  const tooltip1 = (
    <Tooltip>
      Grid View
    </Tooltip>
  );
  const ip = ipp;
  const handleDeleteRow = async (rowId) => {
    try {
      const response = await fetch(`${ipp}/api/products/${rowId}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        // Row deletion was successful, update your local data or refresh the table
        const updatedData = data123.filter((row) => row.id !== rowId);
        setData123(updatedData);
        console.log('Row deleted successfully.');
      } else {
        console.log('Failed to delete row.');
      }
    } catch (error) {
      console.error('Error deleting row:', error);
    }
  };

  const handleEditRow = (rowData) => {
    setEditedRowIds((prevRowIds) => [...prevRowIds, rowData.id]);
    setEditedData((prevData) => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes },
    }));
  };

  const handleSaveRow = async (rowId: string) => {
    try {
      const rowData = data123.find((row) => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowData = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedData[rowId] },
      };
      delete updatedRowData.attributes.CoverImage;
      const response = await fetch(`${ipp}/api/products/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: updatedRowData.attributes }),
      });
      if (response.ok) {
        // If the API call is successful, update the data
        fetchData();
        setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChange = (rowId, fieldName, value) => {
    setEditedData((prevData) => ({
      ...prevData,
      [rowId]: {
        ...prevData[rowId],
        [fieldName]: value,
      },
    }));
  };



  const [categorydata, setCategorydata] = React.useState([]);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcategories`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode,
      }));
      setCategorydata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [colordata, setColordata] = React.useState([]);
  useEffect(() => {
    fetchDataco();
  }, []);
  const fetchDataco = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcolors`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ColorName,
        value: item.attributes.ColorCode,
      }));
      setColordata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [productypedata, setProductypedata] = React.useState([]);
  useEffect(() => {
    fetchDatap();
  }, []);
  const fetchDatap = async () => {
    try {
      const response = await fetch(`${ip}/api/mstproducttypes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode,
      }));
      setProductypedata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [finsihdata, setdFinishata] = React.useState([]);
  useEffect(() => {
    fetchDataf();
  }, []);
  const fetchDataf = async () => {
    try {
      const response = await fetch(`${ip}/api/mstfinishes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.FinishName,
        value: item.attributes.FinishCode,
      }));
      setdFinishata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [materialdata, setMaterialdata] = React.useState([]);
  useEffect(() => {
    fetchDataM();
  }, []);
  const fetchDataM = async () => {
    try {
      const response = await fetch(`${ip}/api/mstmaterials`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.MaterialName,
        value: item.attributes.MaterialCode,
      }));
      setMaterialdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [hsndata, setHsndata] = React.useState([]);
  useEffect(() => {
    fetchDatah();
  }, []);
  const fetchDatah = async () => {
    try {
      const response = await fetch(`${ip}/api/msthscodes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.hscode,
        value: item.attributes.hscode,
      }));
      setHsndata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };



  // const getUniqueData= (data5, property) =>{
  //   let newval = data5.map((curElem)=>{
  //     return curElem[property];
  //   })
  //   console.log(newval);
  // }


  // const categoruOnlyData = getUniqueData(data123, "CategoryName");
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  
  const handleSearch = (value) => {
    setSearchQuery(value);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    
  };
  
  const handleProductTypeChange = (value) => {
    setSelectedProductType(value);
  };
  
  const handleColorChange = (value) => {
    setSelectedColor(value);
  };

  const handleFinishChange = (value) => {
    setSelectedFinish(value);
  };

  const handleHSNChange = (value) => {
    setSelectedhsn(value);
  };

  const handleMaterialChange = (value) => {
    setSelectedmaterial(value);
  };

  

  return (
    <>
      <Stack className="table-toolbar " justifyContent="space-between">
        <Stack direction='column' alignItems='flex-start'>
          <Stack direction='column' >
            <h3 className="title">All Products</h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Product</Breadcrumb.Item>
            </Breadcrumb>
          </Stack>
          <Stack spacing={5}>
            <CheckPicker
              data={categorydata}
              placeholder="Select Category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              block
            />
            {/* <CheckPicker data={categorydata} size="xs" appearance="default" placeholder="Category" style={{ width: 116 }} /> */}

            {/* <CheckPicker data={data1} size="xs" appearance="default" placeholder="Sub Category" style={{ width: 116 }} /> */}
            <CheckPicker
              data={productypedata}
              placeholder="Product Type"
              value={selectedProductType}
              onChange={handleProductTypeChange}
              block
            />
            <CheckPicker
              data={colordata}
              placeholder="Select Color"
              value={selectedColor}
              onChange={handleColorChange}
              block
            />
            {/* <CheckPicker data={data1} size="xs" appearance="default" placeholder="Color" style={{ width: 116 }} /> */}
            <Button appearance="default" active onClick={() => setShowDrawer(true)}>
              More Filter
            </Button>
          </Stack>
        </Stack>
        <Stack direction='column' alignItems='flex-end' spacing={24}>
          <Stack direction='row' spacing={5}>
            <Dropdown title="Add Product" appearance="default" active>
              <div style={{ 'display': 'grid' }}>
                <Link className='link' to='/products-create'><Dropdown.Item><div style={{ 'display': 'flex' }}><div></div><div><strong >Single Upload</strong> <br /> Add a single product</div></div></Dropdown.Item></Link>
                <Link className='link' to='/bulkproduct'><Dropdown.Item><div style={{ 'display': 'flex' }}><div></div><div><strong>Bulk Upload</strong><br /> Upload multiple products at once  </div></div></Dropdown.Item></Link>
              </div>
            </Dropdown>
            <Button color="cyan" appearance="primary">
              Manage Product
            </Button>
          </Stack>
          <Stack spacing={5}>
            <InputGroup inside >
              <Input placeholder="Search" type="text" value={searchQuery} onChange={handleSearch} />
              <InputGroup.Addon>
                <SearchIcon />
              </InputGroup.Addon>
            </InputGroup>
            <Stack >
              <ButtonToolbar>
                <ButtonGroup size="md">
                  <Whisper placement="bottomEnd" controlId="control-id-hover" trigger="hover" speaker={tooltip}>
                    <IconButton icon={<MenuIcon />} active={isActive1} className={showtab === 2 ? "btn btn-outline-secondary" : "btn btn-outline-secondary"} onClick={handleClick1} id="ba" />
                  </Whisper>
                  <Whisper placement="bottomEnd" controlId="control-id-hover" trigger="hover" speaker={tooltip1}>
                    <IconButton icon={<GridIcon />} active={isActive2} className={showtab === 1 ? "btn btn-outline-secondary " : "btn btn-outline-secondary "} onClick={handleClick2} id="bb" />
                  </Whisper>
                </ButtonGroup>
              </ButtonToolbar>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Divider className='divide' />
      <div className={showtab === 1 ? 'row' : ''} id="row">
        <Panel>
          {meta123 && (
            <b style={{ marginLeft: '6px' }}>Total Products: {meta123.pagination.total}</b>
          )}
          <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
            {data123
              .filter(item => {
                // Filter based on the search query
                // Master Search
                const ProductName = item.attributes.ProductName ? item.attributes.ProductName.toLowerCase(): '';
                const AliasCode = item.attributes.ProductId ? item.attributes.ProductId.toLowerCase(): '';
                const ColorName = item.attributes.ColorName ? item.attributes.ColorName.toLowerCase(): '';  
                const HSNCode = item.attributes.HSNCode ? item.attributes.HSNCode.toLowerCase(): '';
                const CategoryName = item.attributes.CategoryName ? item.attributes.CategoryName.toLowerCase() : '';
                const FinishName = item.attributes.FinishName ? item.attributes.FinishName.toLowerCase() : '';
                const SearchKeyword = item.attributes.SearchKeyword ? item.attributes.SearchKeyword.toLowerCase() : '';
                const MOQ = item.attributes.MOQ ? item.attributes.MOQ.toLowerCase() : '';
                const ProductDesigner = item.attributes.ProductDesigner ? item.attributes.ProductDesigner.toLowerCase() : '';
                const MadeBy = item.attributes.MadeBy ? item.attributes.MadeBy.toLowerCase() : '';
                const ProductTypeName = item.attributes.ProductTypeName ? item.attributes.ProductTypeName.toLowerCase() : '';
                // Master Search

                

                const cataCode = item.attributes.CategoryCode;
                const productTypecode = item.attributes.ProductTypeCode;
                const colorcode = item.attributes.ColorCode;
                const finishcode = item.attributes.FinishCode;
                const hsncode = item.attributes.HSNCode;
                const materialcode = item.attributes.MaterialCode;
                

                const categoryMatch = selectedCategory.length === 0 || selectedCategory.includes(cataCode);
                const productTypeMatch = selectedProductType.length === 0 || selectedProductType.includes(productTypecode);
                const colorMatch = selectedColor.length === 0 || selectedColor.includes(colorcode);
                const finishMatch = selectedFinish.length === 0 || selectedFinish.includes(finishcode);
                const hsnMatch = selectedhsn.length === 0 || selectedhsn.includes(hsncode);
                const materialMatch = selectedmaterial.length === 0 || selectedmaterial.includes(materialcode);

                return (
                  // Master Search
                  ProductName.includes(searchQuery.toLowerCase()) ||
                  AliasCode.includes(searchQuery.toLowerCase()) ||
                  ColorName.includes(searchQuery.toLowerCase()) ||
                  CategoryName.includes(searchQuery.toLowerCase()) ||
                  HSNCode.includes(searchQuery.toLowerCase()) ||
                  FinishName.includes(searchQuery.toLowerCase()) ||
                  SearchKeyword.includes(searchQuery.toLowerCase()) ||
                  MOQ.includes(searchQuery.toLowerCase()) ||
                  ProductDesigner.includes(searchQuery.toLowerCase()) ||
                  MadeBy.includes(searchQuery.toLowerCase()) ||
                  ProductTypeName.includes(searchQuery.toLowerCase()) 
                 
                  // Master Search
                 
                )&& categoryMatch && productTypeMatch && colorMatch && finishMatch && hsnMatch && materialMatch;
              })
              .map((item) => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                  <div className="col-md-3" onClick={() => handleOpen('md', item.attributes.ProductId)}>
                    <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                      <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className='imgp' />
                      <div className="overlay">Quick Veiw</div>
                      <Panel>
                        <b>Product Name : {item.attributes.ProductName} </b>
                        <p>
                          Alias Code : {item.attributes.ProductId}
                        </p>
                      </Panel>
                    </Panel>
                  </div>
                </FlexboxGrid.Item>
              ))}

          </FlexboxGrid>

        </Panel>
      </div>
      <div className={showtab === 2 ? "tableform" : ""} id='second' hidden>
        
        <Table
        className='row'
          rowHeight={60}
          data={data123
            .filter(item => {
              const ProductName = item.attributes.ProductName ? item.attributes.ProductName.toLowerCase(): '';
                const AliasCode = item.attributes.ProductId ? item.attributes.ProductId.toLowerCase(): '';
                const ColorName = item.attributes.ColorName ? item.attributes.ColorName.toLowerCase(): '';  
                const HSNCode = item.attributes.HSNCode ? item.attributes.HSNCode.toLowerCase(): '';
                const CategoryName = item.attributes.CategoryName ? item.attributes.CategoryName.toLowerCase() : '';
                const FinishName = item.attributes.FinishName ? item.attributes.FinishName.toLowerCase() : '';
                const SearchKeyword = item.attributes.SearchKeyword ? item.attributes.SearchKeyword.toLowerCase() : '';
                const MOQ = item.attributes.MOQ ? item.attributes.MOQ.toLowerCase() : '';
                const ProductDesigner = item.attributes.ProductDesigner ? item.attributes.ProductDesigner.toLowerCase() : '';
                const MadeBy = item.attributes.MadeBy ? item.attributes.MadeBy.toLowerCase() : '';
                const ProductTypeName = item.attributes.ProductTypeName ? item.attributes.ProductTypeName.toLowerCase() : '';
                // Master Search

                

                const cataCode = item.attributes.CategoryCode;
                const productTypecode = item.attributes.ProductTypeCode;
                const colorcode = item.attributes.ColorCode;
                const finishcode = item.attributes.FinishCode;
                const hsncode = item.attributes.HSNCode;
                const materialcode = item.attributes.MaterialCode;
                

                const categoryMatch = selectedCategory.length === 0 || selectedCategory.includes(cataCode);
                const productTypeMatch = selectedProductType.length === 0 || selectedProductType.includes(productTypecode);
                const colorMatch = selectedColor.length === 0 || selectedColor.includes(colorcode);
                const finishMatch = selectedFinish.length === 0 || selectedFinish.includes(finishcode);
                const hsnMatch = selectedhsn.length === 0 || selectedhsn.includes(hsncode);
                const materialMatch = selectedmaterial.length === 0 || selectedmaterial.includes(materialcode);

                return (
                  // Master Search
                  ProductName.includes(searchQuery.toLowerCase()) ||
                  AliasCode.includes(searchQuery.toLowerCase()) ||
                  ColorName.includes(searchQuery.toLowerCase()) ||
                  CategoryName.includes(searchQuery.toLowerCase()) ||
                  HSNCode.includes(searchQuery.toLowerCase()) ||
                  FinishName.includes(searchQuery.toLowerCase()) ||
                  SearchKeyword.includes(searchQuery.toLowerCase()) ||
                  MOQ.includes(searchQuery.toLowerCase()) ||
                  ProductDesigner.includes(searchQuery.toLowerCase()) ||
                  MadeBy.includes(searchQuery.toLowerCase()) ||
                  ProductTypeName.includes(searchQuery.toLowerCase()) 
                 
                  // Master Search
                 
                )&& categoryMatch && productTypeMatch && colorMatch && finishMatch && hsnMatch && materialMatch;
            })}
          height={450}
          rowKey="id"
          onRowClick={() => { }}
          bordered
        >
          
          <Table.Column width={80} align="center" fixed>
          <HeaderCell><b>Sr. No.</b></HeaderCell>
    <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Category</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.CategoryName || rowData.attributes.CategoryName}
                onChange={(value) => handleInputChange(rowData.id, 'CategoryName', value)}
              />
            ) : (
              rowData.attributes.CategoryName
            )
          )}
            </Cell>
          </Table.Column>
        <Table.Column >
            <Table.HeaderCell><b>P Type</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductTypeName || rowData.attributes.ProductTypeName}
                onChange={(value) => handleInputChange(rowData.id, 'ProductTypeName', value)}
              />
            ) : (
              rowData.attributes.ProductTypeName
            )
          )}
            </Cell>
            
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Alias Code</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductId || rowData.attributes.ProductId}
                onChange={(value) => handleInputChange(rowData.id, 'ProductId', value)}
              />
            ) : (
              rowData.attributes.ProductId
            )
          )}
            </Cell>
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>P Code</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductCode || rowData.attributes.ProductCode}
                onChange={(value) => handleInputChange(rowData.id, 'ProductCode', value)}
              />
            ) : (
              rowData.attributes.ProductCode
            )
          )}
            </Cell>
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Image</b></Table.HeaderCell>
            <Table.Cell >{(rowData) => (
              <img
                src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
                alt="User Image"
                style={{ width: 50, height: 50, marginTop: '-16px' }}
              />
            )}</Table.Cell>
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Product Name</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductName || rowData.attributes.ProductName}
                onChange={(value) => handleInputChange(rowData.id, 'ProductName', value)}
              />
            ) : (
              rowData.attributes.ProductName
            )
          )}
            </Cell>
         
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Description</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Description || rowData.attributes.Description}
                onChange={(value) => handleInputChange(rowData.id, 'Description', value)}
              />
            ) : (
              rowData.attributes.Description
            )
          )}
            </Cell>
            
          </Table.Column>
          
          <Table.Column >
            <Table.HeaderCell><b>Length</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Length || rowData.attributes.Length}
                onChange={(value) => handleInputChange(rowData.id, 'Length', value)}
              />
            ) : (
              rowData.attributes.Length
            )
          )}
            </Cell>
            
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Width</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Width || rowData.attributes.Width}
                onChange={(value) => handleInputChange(rowData.id, 'Width', value)}
              />
            ) : (
              rowData.attributes.Width
            )
          )}
            </Cell>
            
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Height</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Height || rowData.attributes.Height}
                onChange={(value) => handleInputChange(rowData.id, 'Height', value)}
              />
            ) : (
              rowData.attributes.Height
            )
          )}
            </Cell>
           
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Unit</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <InputPicker
              data={sizeUnit}
                value={editedData[rowData.id]?.SizeUnit || rowData.attributes.SizeUnit}
                onChange={(value) => handleInputChange(rowData.id, 'SizeUnit', value)}
              />
            ) : (
              rowData.attributes.SizeUnit
            )
          )}
            </Cell>
            
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Color</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ColorName || rowData.attributes.ColorName}
                onChange={(value) => handleInputChange(rowData.id, 'ColorName', value)}
              />
            ) : (
              rowData.attributes.ColorName
            )
          )}
            </Cell>
            
          </Table.Column>

          <Table.Column >
            <Table.HeaderCell><b>Finish</b></Table.HeaderCell>
            <Cell>
            {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.FinishName || rowData.attributes.FinishName}
                onChange={(value) => handleInputChange(rowData.id, 'FinishName', value)}
              />
            ) : (
              rowData.attributes.FinishName
            )
          )}
            </Cell>
            
          </Table.Column>

          <Table.Column fixed='right'>
            <Table.HeaderCell><b>Action</b></Table.HeaderCell>
            <Table.Cell>
          {(rowData) => (
            editedRowIds.includes(rowData.id) ? (
              <div>
                <IconButton
                  size="sm"
                  icon={<CheckIcon />}
                  active
                  onClick={() => handleSaveRow(rowData.id)}
                  style={{ marginRight: '10px' }}
                />
                <IconButton
                  size="sm"
                  icon={<CloseIcon />}
                  active
                  onClick={() => setEditedRowIds((prevRowIds) => prevRowIds.filter((id) => id !== rowData.id))}
                />
              </div>
            ) : (
              <div>
                <IconButton
                  size="sm"
                  icon={<EditIcon />}
                  active
                  onClick={() => handleEditRow(rowData)}
                />
                {/* You can add a delete button as well if needed */}
              </div>
            )
          )}
        </Table.Cell>
          </Table.Column>
          
        </Table>
      </div>
      <Stack justifyContent='flex-end'>
      {pagination.pageCount > 1 && (
  <Pagination
    prev
    last
    next
    first
    size="xs"
    total={pagination.total}
    limit={pagination.pageSize}
    activePage={pagination.page}
    onChangePage={setActivePage}
  />
)}
      </Stack>
      {/* Modal Section Open*/}
      <Modal size={size} open={open} onClose={handleClose}>
        <Panel
          header={
            <Stack justifyContent="space-between">
              <h5>Product Details</h5>
            </Stack>
          }
        >
          <FlexboxGrid justify="space-around">
      <FlexboxGrid.Item as={Col} colspan={24} md={12}>
      <Stack direction='column' spacing={20}>
              <Stack>
                {modeldata.map((item) => (
                  <div className='imgp1' style={{ zIndex: 1111 }} >
                    <Magnifier
          imageSrc={`${ip}${item.attributes.CoverImage.data.attributes.url}`}
          imageAlt="Wristwatch by Ted Baker London"
          mouseActivation="hover"
          cursorStyle="crosshair"
          dragToMove={false}
          dragToMoveEnabled={false}
          magnifierSize="100%"
          largeImageSrc={`${ip}${item.attributes.CoverImage.data.attributes.url}`}
          largeImageAlt="Wristwatch by Ted Baker London (Large)"
          enlargedImagePosition="over"
        />
                  </div>
                  // <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className='imgp1' />
                ))}

              </Stack>
              <div className="scroll-container">
                {multipleImages.length > 0 ? (
                  <Stack spacing={10} style={{marginTop:'60px'}}>
                    {multipleImages.map((image) => (
                      <img
                        src={`${ip}${image.attributes.url}`}
                        className="imgp2"
                        key={image.id}
                      />
                    ))}
                  </Stack>
                ) : (
                  <></>
                )}
              </div>
            </Stack>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item as={Col} colspan={24} md={12}>
      {modeldata.map((item) => (
                <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginBottom:'8px'}}>
                <b>Alias Code :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.ProductId}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Product Name :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.ProductName}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Size :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                  <Stack spacing={10}>
                <p>{item.attributes.SizeUnit}</p>
                <b>L</b>
                <p>{item.attributes.Length}</p>
                <b>W</b>
                <p>{item.attributes.Width}</p>
                <b>H</b>
                <p>{item.attributes.Height}</p>
                </Stack>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Category Name :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.CategoryName}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Product Type Name :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.ProductTypeName}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Finish Name :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.FinishName}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Color Name :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.ColorName}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Buyer Name :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.BuyerName}
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}style={{marginBottom:'8px'}}>
                <b>Description :</b>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                {item.attributes.Description}
                </FlexboxGrid.Item>
                
                
              </FlexboxGrid>
              ))}
      </FlexboxGrid.Item>
    </FlexboxGrid> 
        </Panel>
        <Stack justifyContent='flex-end'>
          <Button onClick={handleClose} color='cyan' appearance='primary'>Done</Button>
        </Stack>
      </Modal>


      <Drawer size="xs" backdrop="static" open={showDrawer} onClose={() => setShowDrawer(false)}>
        <Drawer.Header>
          <Drawer.Title>Filters</Drawer.Title>
          <Drawer.Actions>
            <Button onClick={() => setShowDrawer(false)} appearance="ghost" color="cyan">Cancel</Button>
            <Button onClick={() => setShowDrawer(false)} appearance="primary"color="cyan" >
              Confirm
            </Button>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
        <Stack direction='column' alignItems='center'>
        <CheckPicker value={selectedFinish}
              onChange={handleFinishChange} data={finsihdata} placement="autoVerticalStart" placeholder="Select Finish" style={{ width: 350,  marginBottom: 20 , marginTop:20   }} />
        <CheckPicker value={selectedhsn}
              onChange={handleHSNChange} data={hsndata} placement="autoVerticalStart" placeholder="Select HSN" style={{ width: 350,  marginBottom: 20}} />
        <CheckPicker value={selectedmaterial}
              onChange={handleMaterialChange} data={materialdata} placement="autoVerticalStart" placeholder="Select Material" style={{ width: 350,  marginBottom: 20 }} />
        </Stack>
        </Drawer.Body>
      </Drawer>
      

      <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
        <div className="container">
          <p>© All Right Reserved. Product by </p>
        </div>
        <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
      </Stack>
      
    </>
  );
};
export default DataTable;

